export function accountMoney(value: unknown): number {
  const amount = Number(value);
  return Number.isFinite(amount) ? Math.round(amount * 100) / 100 : 0;
}

export function accountDate(value: any): string | undefined {
  if (!value) return undefined;
  if (typeof value.format === 'function') return value.format('YYYY-MM-DD');
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return undefined;
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(
    date.getDate()
  ).padStart(2, '0')}`;
}

export function accountStatusLabel(status?: string): string {
  const labels: Record<string, string> = {
    POSTED: 'Проведено',
    COMPLETED: 'Выполнено',
    SUCCESS: 'Выполнено',
    SUCCEEDED: 'Выполнено',
    PENDING: 'Ожидает подтверждения',
    PENDING_BANK: 'Ожидает банк',
    PENDING_CONFIRMATION: 'Ожидает подтверждения',
    PROCESSING: 'В обработке',
    RESERVED: 'Средства удержаны',
    FAILED: 'Ошибка',
    CANCELLED: 'Отменено',
    CANCELED: 'Отменено',
    REVERSED: 'Сторнировано',
    PARTIAL: 'Частично выполнено',
    DRAFT: 'Черновик'
  };
  return labels[status || ''] || '—';
}

export function accountKindLabel(kind?: string): string {
  const labels: Record<string, string> = {
    TOPUP: 'Пополнение',
    TOPUP_CASH: 'Пополнение наличными',
    TOPUP_BANK: 'Пополнение безналом',
    DEPOSIT: 'Пополнение',
    BANK_CONFIRM: 'Подтверждение банка',
    CONFIRM_BANK: 'Подтверждение банка',
    CANCEL_PENDING: 'Отмена ожидающей операции',
    ALLOCATE: 'Зачёт в заказ',
    ALLOCATION: 'Зачёт в заказ',
    PAYOUT: 'Выплата клиенту',
    REFUND: 'Выплата клиенту',
    RETURN_RELEASE: 'Освобождение после возврата',
    RETURN_CREDIT: 'Возврат на баланс',
    RELEASE: 'Возврат на баланс',
    COMMITMENT: 'Оплата заказа',
    SHIPMENT: 'Отгрузка',
    REVERSE: 'Сторно',
    REVERSAL: 'Сторно',
    OPENING: 'Входящий остаток',
    MIGRATION: 'Начальное сальдо',
    ADJUSTMENT: 'Корректировка',
    DOCUMENT_CHANGE: 'Изменение обязательств'
  };
  return labels[kind || ''] || 'Операция';
}

export function accountError(error: any, fallback: string): string {
  const body = error?.error || error;
  if (Array.isArray(body?.message)) return body.message.join('. ');
  return typeof body?.message === 'string' ? body.message : fallback;
}

export function accountBlockedMessage(reason?: string | null): string {
  const labels: Record<string, string> = {
    CLIENT_ACCOUNT_DISABLED: 'Операции по балансу для этой организации ещё не включены.',
    CLIENT_ACCOUNT_RECONCILIATION_REQUIRED: 'Начальные остатки организации ещё не сверены.'
  };
  return reason
    ? labels[reason] ||
        (/^[A-Z_0-9]+$/.test(reason)
          ? 'Операции по балансу пока недоступны для этой организации.'
          : reason)
    : '';
}

export function downloadAccountBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
